import { LayoutsUploadModal } from "../layouts-upload-modal"
import { CheckRes, CheckResResultPage, LayoutState, PartData, UploadRes } from "../types/types"
import { getErrors } from "../utils/checkLayoutErrors"
import { createChevronLeftIcon, createCloseIcon, createEllipsIcon, createInfoIcon, createLayout, createModal, createRotateIcon } from "../utils/createElemets"
import { createLayoutErrorsModal } from "../utils/createLayoutErrorsModal"

// --------------------------------------------------------------------------------

export class LayoutsViewer {

    #partDataId: string
    #index: number
    #activeLayoutState?: LayoutState | null
    #activePage: number
    #pages: number

    #root: ShadowRoot | null
    #modal: HTMLDivElement
    #container: HTMLDivElement
    #header: HTMLDivElement
    #slidesList: HTMLDivElement
    #activeSlide: HTMLDivElement
    #activeSlideResizeObserver: ResizeObserver

    constructor(partDataId: string, layoutIndex: number, page: number, root: ShadowRoot | null) {
        this.#partDataId = partDataId
        this.#index = layoutIndex
        this.#activePage = page
        this.#pages = 0
        this.#root = root

        this.#header = document.createElement('div')
        this.#header.classList.add('layout-viewer-header')

        this.#slidesList = document.createElement('div')
        this.#slidesList.classList.add('layout-viewer-slides')

        this.#activeSlide = document.createElement('div')
        this.#activeSlide.classList.add('layout-viewer-active-slide')

        this.#activeSlideResizeObserver = new ResizeObserver(() => { })

        this.#modal = document.createElement('div')
        this.#container = document.createElement('div')
        this.#container.onclick = e => e.stopPropagation()

        this.#modal.classList.add('layout-viewer-container')
        this.#modal.onclick = e => {
            e.stopPropagation()
            this.closeModal()
        }

        // ----------

        this.#activeLayout = layoutsState[partDataId][layoutIndex]

        layoutsState[partDataId].map((layoutState, index) => {
            if (!layoutState) return

            if (layoutState.checkResData) {
                Object.values(layoutState.checkResData.result).forEach((result) => {
                    this.#pages += result.pages.length
                    result.pages.forEach((pageObj, pageIndex) => {
                        Object.entries(pageObj).forEach(([number, page]) => {
                            const slide = document.createElement('div')
                            slide.classList.add('slide')

                            if (index === this.#activeLayout?.index && pageIndex === this.#activePage) {
                                slide.classList.add('active')
                                setTimeout(() =>
                                    slide.scrollIntoView({ block: 'center' }))
                            }

                            const printingSides = layoutState?.partData.countPrintingSides
                            if (partDataId && layoutsState[partDataId].length > 1) {
                                const span = document.createElement('span')
                                span.append(printingSides && printingSides === 2
                                    ? index < 2
                                        ? index === 0
                                            ? 'Лицевая'
                                            : 'Оборотная'
                                        : ''
                                    : '')
                                slide.append(span)
                            }

                            const layout = createLayout(layoutState, page)
                            layout.onclick = (e) => {
                                this.#activePage = pageIndex
                                this.#activeLayout = layoutState
                            }

                            slide.append(layout)
                            this.#slidesList.append(slide)
                        })
                    })
                })

            } else {

                const slide = document.createElement('div')
                slide.classList.add('slide')

                if (index === this.#activeLayout?.index && 0 === this.#activePage) {
                    slide.classList.add('active')
                    setTimeout(() =>
                        slide.scrollIntoView({ block: 'center' }))
                }

                const printingSides = layoutState?.partData.countPrintingSides
                if (partDataId && layoutsState[partDataId].length > 1) {
                    const span = document.createElement('span')
                    span.append(printingSides && printingSides === 2
                        ? index < 2
                            ? index === 0
                                ? 'Лицевая'
                                : 'Оборотная'
                            : ''
                        : '')
                    slide.append(span)
                }

                const layout = createLayout(layoutState)
                layout.onclick = (e) => {
                    this.#activePage = 0
                    this.#activeLayout = layoutState
                }

                slide.append(layout)
                this.#slidesList.append(slide)
            }
        })

        const closeBtn = document.createElement('button')
        closeBtn.classList.add('close')
        closeBtn.append(createCloseIcon('var(--gray-800, #2D3748)'))
        closeBtn.onclick = () => this.closeModal()

        const replaceLayoutBtn = document.createElement('button')
        replaceLayoutBtn.classList.add('replace-btn')
        replaceLayoutBtn.type = 'button'
        replaceLayoutBtn.textContent = 'Заменить макет'
        replaceLayoutBtn.onclick = () => createModal({
            title: 'Вы уверены что хотите заменить?',
            subTitle: 'Вы вернетесь в режим проверки и загрузки макетов, этот макет будет удален',
            submitText: 'Да, заменить',
            cancelText: 'Отменить',
            action: () => {
                if (!this.#activeLayout) return

                let temp = layoutsState[this.#activeLayout.partData.id].slice()

                const uploadModal = layoutsUploadModal as LayoutsUploadModal

                if (uploadModal.twoSidePdf) {
                    temp[1] = null
                    temp[0] = null
                    uploadModal.twoSidePdf = false
                } else {
                    temp[this.#activeLayout.index] = null
                }

                layoutsState[this.#activeLayout.partData.id] = temp

                if (uploadModal.step !== 1) uploadModal.step = 1

                this.closeModal()

            }
        }, root)
        replaceLayoutBtn.prepend(createRotateIcon())

        this.#container.append(this.#header, this.#activeSlide, this.#slidesList, replaceLayoutBtn, closeBtn)

        // ----------



        // ----------

        this.#modal.append(this.#container)
        root?.append(this.#modal)

        setTimeout(() => this.#modal.classList.add('visible'))
    }

    get #activeLayout() {
        return this.#activeLayoutState
    }

    set #activeLayout(activeLayout) {
        this.#activeLayoutState = activeLayout
        if (!activeLayout || !this.#partDataId) return

        if (this.#slidesList)
            Array.from(this.#slidesList.children).forEach((child, slideIndex) => {
                const isActive = slideIndex === (this.#activePage + activeLayout.index)
                child.classList.toggle('active', isActive)

                if (isActive)
                    child.scrollIntoView({ behavior: 'smooth', block: 'center' })
            })

        this.#activeSlideResizeObserver.disconnect()
        this.#activeSlideResizeObserver = new ResizeObserver(([entry]) => {
            const aspectRatio = entry.contentRect.width / entry.contentRect.height
            const productAspectRatio = +activeLayout.partData.size.width / +activeLayout.partData.size.height

            entry.target.children[0].classList.toggle('fit-height', aspectRatio >= productAspectRatio)
            entry.target.children[0].classList.toggle('fit-width', aspectRatio < productAspectRatio)
        })
        this.#activeSlideResizeObserver.observe(this.#activeSlide)

        // ----------
        const h3 = document.createElement('h3')
        h3.textContent = activeLayout.uploadResData.original_name
        const partDataName = document.createElement('span')
        partDataName.textContent = activeLayout.partData.name

        const subtitle = activeLayout?.partData.countPrintingSides === 2
            ? this.#index === 0
                ? 'Лицевая'
                : 'Оборотная'
            : undefined

        if (subtitle)
            partDataName.append(createEllipsIcon(), subtitle)

        if (this.#header.children.length > 0)
            this.#header.replaceChildren(h3, partDataName)
        else
            this.#header.append(h3, partDataName)

        const { errors, warnings } = getErrors(activeLayout.checkResData)

        if (errors || warnings) {
            const error = document.createElement('div')

            const errorLink = document.createElement('button')
            errorLink.textContent = errors ? 'Смотреть критичные замечания' : 'Смотреть замечания'
            errorLink.onclick = () => {
                createLayoutErrorsModal(activeLayout, activeLayout.index, this.#root, this)
            }

            error.append(
                createInfoIcon('warning'),
                'Есть замечания, которые повлияют на результат',
                errorLink
            )
            this.#header.append(error)
        }

        // ----------

        const layoutPages = activeLayout.checkResData
            ? Object.values(activeLayout.checkResData?.result)[0].pages
            : undefined

        let page = undefined

        if (layoutPages)
            page = Object.values(layoutPages[this.#activePage])[0]

        const activeLayoutContainer = createLayout(activeLayout, page, true)
        activeLayoutContainer.classList.add('active')

        let prevBtnVisible = false
        if (this.#activePage > 0) {
            prevBtnVisible = true
        } else if (activeLayout.index - 1 >= 0) {
            prevBtnVisible = true
        }

        let nextBtnVisible = false
        const currentLayoutPages = activeLayout.checkResData
            ? Object.values(activeLayout.checkResData.result)[0].pages
            : []
        if (this.#activePage < currentLayoutPages.length - 1) {
            nextBtnVisible = true
        } else if (activeLayout.index < layoutsState[this.#partDataId].length - 1) {
            nextBtnVisible = true
        }
        const prev = document.createElement('button')
        prev.classList.add('prev')
        prev.append(createChevronLeftIcon())
        prev.onclick = () => {
            if (!this.#partDataId) return

            if (this.#activePage > 0) {
                this.#activePage--
                this.#activeLayout = layoutsState[this.#partDataId][activeLayout.index]
            } else if (activeLayout.index - 1 >= 0) {
                this.#activePage = 0
                this.#activeLayout = layoutsState[this.#partDataId][activeLayout.index - 1]
            }
        }

        const next = document.createElement('button')
        next.classList.add('next')
        next.append(createChevronLeftIcon())
        next.onclick = () => {
            if (!this.#partDataId || !activeLayout?.checkResData) return

            const currentLayoutPages = Object.values(activeLayout.checkResData.result)[0].pages

            if (this.#activePage < currentLayoutPages.length - 1) {
                this.#activePage++
                this.#activeLayout = layoutsState[this.#partDataId][activeLayout.index]
            } else if (activeLayout.index < layoutsState[this.#partDataId].length - 1) {
                this.#activePage = 0
                this.#activeLayout = layoutsState[this.#partDataId][activeLayout.index + 1]
            }
        }

        this.#activeSlide.innerHTML = ''
        this.#activeSlide.append(activeLayoutContainer)

        if (nextBtnVisible)
            this.#activeSlide.append(next)

        if (prevBtnVisible)
            this.#activeSlide.append(prev)

    }

    closeModal() {
        this.#modal.classList.remove('visible')
        setTimeout(() => this.#modal.remove(), 300)
    }

}